import { render, staticRenderFns } from "./AppOrderList.vue?vue&type=template&id=9daaaffe&scoped=true&"
import script from "./AppOrderList.vue?vue&type=script&lang=js&"
export * from "./AppOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daaaffe",
  null
  
)

export default component.exports